import { createHOC } from 'vue-hoc';

import ResetPasswordForm from './ResetPasswordForm';
import auth from '../../../../lib/common/providers/auth';

const options = {
  name: 'ResetPasswordFormContainer',
  data() {
    return {
      state: {
        error: null,
        loading: false,
        emailSent: false,
      },
    };
  },
  created() {
  }
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    emailSent() {
      return this.state.emailSent;
    },
  },
  listeners: {
    async resetPassword(email) {
      this.state.error = null;
      this.state.loading = true;
      try {
        await auth.sendPasswordReset(email);
        this.state.emailSent = true;
      } catch (error) {
        this.state.error = { ...error, message: error.description };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const ResetPasswordFormContainer = createHOC(ResetPasswordForm, options, renderWith);
export default ResetPasswordFormContainer;
